import { useState, useEffect } from 'react';

export function useServiceWorker() {
    const [registration, setRegistration] = useState(null);
    const [error, setError] = useState(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        async function registerServiceWorker() {
            if ('serviceWorker' in navigator) {
                try {
                    const registration = await navigator.serviceWorker.register('/service-worker.js');
                    setRegistration(registration);
                    setIsReady(true);
                    console.log('Service Worker registered successfully');

                    // Attendre que le service worker soit actif
                    if (registration.waiting) {
                        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                    }
                } catch (error) {
                    setError(error);
                    console.error('Service Worker registration failed:', error);
                }
            }
        }

        registerServiceWorker();
    }, []);

    return { registration, error, isReady };
}